import {
  Button,
  getPrimaryColor,
  isMobileAtom,
  Styles,
  useRecoil,
} from '@orcar/common-d2c';
import { useState } from 'react';
import styled from 'styled-components';
import { app } from '@/constants/common';
import InsuranceInfoModal from '@/pages/search/components/asideFilter/InsuranceInfoModal';
import MobileInsuranceInfoModal from '@/pages/search/mobile/components/filter/MobileInsuranceInfoModal';
import { SingleInsuranceTable } from './SingleInsuranceTable';
import * as S from './styles';

type InsuranceInfoProps = {
  isFullCoverage?: boolean;
  insurance?: string;
  companyName: string;
  coverageLimit: string;
  deductible: string;
  lossOfUseFee: string;
};

const InsuranceInfo = ({
  isFullCoverage,
  insurance,
  companyName,
  coverageLimit,
  deductible,
  lossOfUseFee,
}: InsuranceInfoProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { recoilValue: isMobile } = useRecoil(isMobileAtom);

  return (
    <>
      <S.Text type='title'>가입된 보험 정보</S.Text>
      <Space />
      <SingleInsuranceTable
        isFullCoverage={isFullCoverage}
        insurance={insurance}
        companyName={companyName}
        coverageLimit={coverageLimit}
        deductible={deductible}
        lossOfUseFee={lossOfUseFee}
      />
      <S.Text type='subInfo'>
        보험은 현장에서 작성하는 계약서를 기준으로 적용되어요. 반드시 차량 이용
        전 계약서를 꼼꼼히 확인해주세요.
      </S.Text>
      <Button
        width='125px'
        height='30px'
        bgColor={Styles.COLOR.WHITE}
        color={getPrimaryColor(app)}
        borderColor={getPrimaryColor(app)}
        font={Styles.FONT.B3}
        onClick={() => setIsModalOpen(true)}
      >
        보험이 궁금하세요?
      </Button>
      {isModalOpen ? (
        isMobile ? (
          <MobileInsuranceInfoModal onClose={() => setIsModalOpen(false)} />
        ) : (
          <InsuranceInfoModal onClose={() => setIsModalOpen(false)} />
        )
      ) : undefined}
    </>
  );
};

export default InsuranceInfo;

const Space = styled.div`
  margin: 15px 0;
`;
